import { render, staticRenderFns } from "./TableColumn.vue?vue&type=template&id=4a8d5c21"
import script from "./TableColumn.vue?vue&type=script&lang=js"
export * from "./TableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a8d5c21')) {
      api.createRecord('4a8d5c21', component.options)
    } else {
      api.reload('4a8d5c21', component.options)
    }
    module.hot.accept("./TableColumn.vue?vue&type=template&id=4a8d5c21", function () {
      api.rerender('4a8d5c21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/base-table/components/TableColumn.vue"
export default component.exports